export const initialContent = {
  // Navigation
  "nav-brand-title": "Precision Dynamics Mfg.",
  "nav-brand-location": "Cedar Rapids, IA",
  
  // Hero Section
  "hero-title": "Precision Engineering for Aerospace & Defense",
  "hero-description": "Leading manufacturer of high-precision machined components for critical applications in aerospace and defense industries.",
  "hero-btn-primary": "Our Capabilities",
  "hero-btn-secondary": "Get Quote",
  
  // About Section
  "about-title": "About Precision Dynamics",
  "about-text-1": "With over 80 years of experience in precision manufacturing, Precision Dynamics Manufacturing has established itself as a trusted partner for aerospace and defense contractors requiring the highest quality machined components.",
  "about-text-2": "Located in Cedar Rapids, Iowa, our state-of-the-art facility combines advanced CNC machining technology with rigorous quality control processes to deliver components that meet the most demanding specifications.",
  "stat-1-number": "80",
  "stat-1-label": "Years Experience",
  "stat-2-number": "500,000",
  "stat-2-label": "Parts Delivered", 
  "stat-3-number": "99.9%",
  "stat-3-label": "Quality Rating",
  
  // Capabilities Section
  "capabilities-title": "Manufacturing Capabilities",
  "capability-1-title": "CNC Machining",
  "capability-1-description": "5-axis CNC machining centers capable of producing complex geometries with tolerances to ±0.0001\"",
  "capability-2-title": "Materials",
  "capability-2-description": "Aluminum alloys, titanium, stainless steel, Inconel, and other aerospace-grade materials",
  "capability-3-title": "Inspection",
  "capability-3-description": "CMM inspection, surface finish analysis, and complete dimensional verification",
  "capability-4-title": "Finishing",
  "capability-4-description": "Anodizing, passivation, and specialized coatings for enhanced performance",
  
  // Industries Section
  "industries-title": "Industries Served",
  "aerospace-title": "Aerospace",
  "aerospace-item-1": "Aircraft structural components",
  "aerospace-item-2": "Engine parts and assemblies",
  "aerospace-item-3": "Landing gear components",
  "aerospace-item-4": "Avionics housings",
  "defense-title": "Defense",
  "defense-item-1": "Missile guidance systems",
  "defense-item-2": "Radar components",
  "defense-item-3": "Weapon system parts",
  "defense-item-4": "Communications equipment",
  "space-title": "Space",
  "space-item-1": "Satellite components",
  "space-item-2": "Launch vehicle parts",
  "space-item-3": "Instrumentation housings",
  "space-item-4": "Thermal management systems",
  
  // Quality Section
  "quality-title": "Quality & Certifications",
  "certifications-title": "Certifications",
  "cert-1": "AS9100D - Quality Management Systems",
  "cert-2": "ISO 9001:2015 - Quality Management",
  "cert-3": "NADCAP - Special Processes",
  "cert-4": "ITAR - International Traffic in Arms",
  "quality-process-title": "Quality Process",
  "quality-process-description": "Our quality management system ensures every component meets or exceeds customer specifications through:",
  "quality-item-1": "First article inspection",
  "quality-item-2": "In-process quality checks",
  "quality-item-3": "Final inspection and documentation",
  "quality-item-4": "Traceability and material certification",
  
  // Contact Section
  "contact-title": "Contact Us",
  "contact-info-title": "Get in Touch",
  "contact-address-label": "Address:",
  "contact-address": "8080 Industrial Blvd\nCedar Rapids, IA",
  "contact-phone-label": "Phone:",
  "contact-phone": "(319) 423-9926",
  "contact-email-label": "Email:",
  "contact-email": "info@precisiondynamicsmfg.com",
  "contact-hours-label": "Hours:",
  "contact-hours": "Monday - Friday: 7:00 AM - 5:00 PM",
  "contact-form-title": "Request Quote",
  
  // Footer
  "footer-brand-title": "Precision Dynamics Mfg.",
  "footer-brand-description": "Precision Engineering for Critical Applications",
  "footer-links-title": "Quick Links",
  "footer-contact-title": "Contact",
  "footer-contact-location": "Cedar Rapids, IA",
  "footer-contact-phone": "(319) 423-9926",
  "footer-copyright": "© 2024 Precision Dynamics Manufacturing. All rights reserved."
};